<template>
    <v-layout justify-center>
        <v-responsive max-width="1280" width="100%" height="100%">
            <list-heading v-model="showsSearch" title="언론의신뢰" showsFilterButton>
                <template #add-button>
                    <press-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn small fab tile color="transparent primary--text" class="my-n1" v-bind="{ ...attrs, loading }" v-on="on"> <v-icon>mdi-plus</v-icon> </v-btn>
                        </template>
                    </press-form>
                </template>
            </list-heading>

            <list-search-default v-bind="{ showsSearch, loading, searchKeys }" />

            <press-list-labels class="mb-3" />

            <v-data-table v-bind="{ items, headers, loading }" :items-per-page="-1" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" style="overflow: hidden" ref="data-table">
                <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value)" /> </template>

                <template #[`item.thumbnail`]="{ value }">
                    <v-img :src="value" width="80"></v-img>
                </template>

                <template #[`item.videoId`]="{ value }">
                    <v-btn text icon tile :href="`https://youtu.be/${value}`" target="_blank">
                        <v-icon small>mdi-open-in-new</v-icon>
                    </v-btn>
                </template>

                <template #[`item.isNotice`]="{ item }">
                    <v-switch v-model="item.isNotice" v-bind="attrs_switch__console" @change="(isNotice) => update({ _id: item._id, isNotice })" />
                </template>

                <template #[`item.actions`]="{ item }">
                    <press-form :value="item" @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn text icon tile v-bind="attrs" v-on="on">
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                    </press-form>

                    <v-btn text icon tile @click="remove(item)">
                        <v-icon small> mdi-delete </v-icon>
                    </v-btn>
                </template>

                <template #footer>
                    <v-divider />
                    <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
                </template>
            </v-data-table>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch__console } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list-search-default.vue";
import PressForm from "@/components/console/press/press-form.vue";
import PressListLabels from "@/components/console/press/press-list-labels.vue";

let headers = [
    { text: "#", value: "rank", width: +60, align: "end" },
    { text: "썸네일", value: "thumbnail", width: +80, cellClass: "py-1" },
    { text: "라벨", value: "label", width: +80, align: "center" },
    { text: "유튜브", value: "videoId", width: +80, align: "center" },
    { text: "제목", value: "title" },
    { text: "공지여부", value: "isNotice", width: +80, align: "center" },
    { text: "작성일", value: "createdAt", width: 110, formatter: (value) => value?.toDateTime?.() || value || "-" },
    { text: "", value: "actions", width: 100, cellClass: "px-0", align: "center" },
].map((item, index, array) => ({ ...item, divider: index != array.length - 1, cellClass: (item.cellClass || "") + ` caption`, formatter: item.formatter ?? ((value) => value ?? "-") }));

let searchKeys = [{ text: "제목", value: "title" }];

export default {
    components: {
        ListHeading,
        ListSearchDefault,
        PressForm,
        PressListLabels,
    },
    data: () => ({
        medias: [],

        limit: 20,
        summary: { totalCount: 0 },

        headers,
        searchKeys,
        attrs_switch__console,

        dialog: false,
        loading: false,
        showsSearch: true,
    }),
    computed: {
        items() {
            return [...this.medias];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.type = "목록";

            return { ...query };
        },

        disabled__drag() {
            return JSON.stringify(this.code) == JSON.stringify([...Object.values({}).filter(({ shows }) => shows)].map(({ value }) => value)) || this.loading;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.medias = [];
            this.summary = { totalCount: 0 };

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, medias } = await api.console.media.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.medias = medias;
            } finally {
                this.loading = false;
            }
        },

        async update(form) {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { media } = await api.console.media.put(form);
                this.updateItem(media);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        async remove(media) {
            if (this.loading) return;
            else this.loading = true;

            try {
                if (confirm("해당 게시물을 삭제하시겠습니까?")) {
                    await api.console.media.delete(media);
                    await this.search();
                }
            } finally {
                this.loading = false;
            }
        },

        updateItem(item) {
            const index = this.medias.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.medias.splice(index, 1, item);
            else {
                this.medias = [item, ...this.medias];
                this.summary.totalCount += 1;
            }
            this.search();
        },

        async setNewIndex({ moved = {} }) {
            let {
                element: { _id, rank },
                oldIndex,
                newIndex,
            } = moved;
            rank += oldIndex - newIndex;
            let form = { _id, rank };
            this.update(form);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .max-width-0 {
        max-width: 0;
    }
    .line-height-1-5 {
        line-height: 1.5;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__mobile-row__cell {
        max-width: calc(100vw - 12px - 16px - 80px - 16px - 12px);
    }
}
</style>
